import { teeupStatusKeys } from "@config/enums"
import { Stage, TEEUP_STATUS } from "types/teeup"

// DEV-FIX 2026-07-04: restored to the per-stage status colors from the iPhone gold standard
// (F:\AI_Data\CODE-REPOS\teeup-mobile\app\configs\teeupStage.ts) -- the 2026-07-03 blue-family
// recolor (see prior comment, removed) made Planning/Scheduled/All Set visually indistinguishable.
// Structure/logic (position, isSelected, isHidden, isDisabled, statusId) left untouched -- colors only.
export const getStageOptions = (): Stage[] => [
  {
    label: teeupStatusKeys.planning,
    position: 0,
    isSelected: true,
    color: "#F9861A",
    backgroundColor: "#FEF3E8",
    labelToDisplay: "Planning",
    statusId: TEEUP_STATUS.PLANNING,
  },
  {
    // BUG-036 / DEV-FIX 2026-07-04 (Scheduled as a first-class timeline stage): was
    // isHidden:true (excluded from the visible TimeLine, position collided with All Set at 1).
    // Now shown in its correct sequence position (Planning -> Scheduled -> All Set -> Happening
    // Soon -> Happening -> Ended). Still DISPLAY-only: isDisabled (like Happening Soon) plus the
    // changeStatus() "scheduled" no-op guard in DropDown/index.tsx mean it is never a manually
    // selectable transition -- it only lights up when the backend's derived active.status is
    // actually "scheduled" (When decided, Where undecided). Selection/derivation logic unchanged.
    label: "scheduled",
    position: 1,
    isSelected: false,
    color: "#2F80ED",
    backgroundColor: "#EAF2FE",
    labelToDisplay: "Scheduled",
    isDisabled: true,
    statusId: TEEUP_STATUS.SCHEDULED,
  },
  {
    label: teeupStatusKeys.allset,
    position: 2,
    isSelected: false,
    color: "#00B39E",
    backgroundColor: "#E6F9F7",
    labelToDisplay: "All Set",
    statusId: TEEUP_STATUS.ALL_SET,
  },
  {
    label: teeupStatusKeys.happeningSoon,
    position: 3,
    isSelected: false,
    color: "#7B61FF",
    backgroundColor: "#F2EFFF",
    labelToDisplay: "Happening soon",
    isDisabled: true,
    statusId: TEEUP_STATUS.HAPPENING_SOON,
  },
  {
    label: teeupStatusKeys.happening,
    position: 4,
    isSelected: false,
    color: "#0AC6FF",
    backgroundColor: "#E7F9FF",
    labelToDisplay: "Happening now",
    statusId: TEEUP_STATUS.HAPPENING,
  },
  {
    label: teeupStatusKeys.ended,
    position: 5,
    isSelected: false,
    // near-black per mobile AppColors.brand.blackNeutral900 (~#1A1A1A); using the web's existing
    // near-black text token (theme/colors.js textPrimary #222222) as the closest equivalent.
    color: "#222222",
    backgroundColor: "#F5F5F5",
    labelToDisplay: "Ended",
    statusId: TEEUP_STATUS.ENDED,
  },
  {
    label: teeupStatusKeys.cancelled,
    position: 6,
    isSelected: false,
    // mobile AppColors.coowe.error100 (#EF4444) -- matches the web's existing --red2 token
    // (assets/styles/newColors.scss); background/border from mobile teeupStage.ts Cancelled.
    color: "#EF4444",
    backgroundColor: "#FDECEC",
    labelToDisplay: "Ended",
    isHidden: true,
    statusId: TEEUP_STATUS.CANCELLED,
  },
]

// DEV-FIX 2026-07-04: restored to the iPhone gold standard per-stage colors
// (F:\AI_Data\CODE-REPOS\teeup-mobile\app\configs\teeupStage.ts) -- the 2026-07-03 blue-family
// recolor (see prior comment, removed) made every stage chip look the same. Normalized to the
// mobile's uniform tinted-background + colored-text + colored-border pattern for every stage
// (the prior solid-fill/white-text rows on ALL_SET/SCHEDULED/HAPPENING_SOON/HAPPENING were an
// inconsistency introduced by that recolor, not a deliberate style choice).
export const getStageOptionsByStatusId = () => {
  return {
    [TEEUP_STATUS.PLANNING]: {
      label: "Planning",
      className: "text-[#F9861A] border-[#FCC796] bg-[#FEF3E8]",
    },
    // BUG-036: Scheduled (When decided, Where NOT decided) gets a distinct badge.
    [TEEUP_STATUS.SCHEDULED]: {
      label: "Scheduled",
      className: "text-[#2F80ED] border-[#A9CBF7] bg-[#EAF2FE]",
    },
    [TEEUP_STATUS.ALL_SET]: {
      label: "All Set",
      className: "text-[#00B39E] border-[#8AE4DA] bg-[#E6F9F7]",
    },
    [TEEUP_STATUS.HAPPENING_SOON]: {
      label: "Happening Soon",
      className: "text-[#7B61FF] border-[#C2B6FF] bg-[#F2EFFF]",
    },
    [TEEUP_STATUS.HAPPENING]: {
      // "Happening now" isn't one of the spec's six named states but exists in our data model;
      // mapped to the mobile "Happening" cyan (judgment call, not spec-enumerated).
      label: "Happening now",
      className: "text-[#0AC6FF] border-[#8EE5FF] bg-[#E7F9FF]",
    },
    [TEEUP_STATUS.ENDED]: {
      // near-black per mobile AppColors.brand.blackNeutral900 (~#1A1A1A); using the web's
      // existing near-black text token (theme/colors.js textPrimary #222222) as the closest
      // equivalent; background/border from mobile teeupStage.ts Ended (grey).
      label: "Ended",
      className: "text-[#222222] border-[#E5E5E5] bg-[#F5F5F5]",
    },
    [TEEUP_STATUS.CANCELLED]: {
      // mobile AppColors.coowe.error100 (#EF4444) -- matches the web's existing --red2 token
      // (assets/styles/newColors.scss); background/border from mobile teeupStage.ts Cancelled.
      label: "Cancelled",
      className: "text-[#EF4444] border-[#FAC5C5] bg-[#FDECEC] line-through",
    },
  }
}

export const removedStageOption = {
  label: "You have been removed",
  className: "text-red-500 bg-rose-50 border-red-200",
}
